
import React from 'react';
import checkIcon from '../assets/images/check.svg';
import phoneIcon from '../assets/images/phonenumbericon.svg';
import '../assets/styles/PricingSection.css'; // Assuming you have a CSS file for styles
const PricingSection = () => {
  return (
    <section className="pricing-section py-5" id="pricing">
      <div className="container" style={{ maxWidth: '1400px' }}>
      <div className="text-center mb-5">
      <h2 className="fw-bold text-dark text-center display-5 mb-4">Simple, Transparent Pricing</h2>
        <p className="text-muted fs-5">
          Our credit-based system gives you flexibility in how you use our services. Purchase credits upfront and use
          them whenever you need maintenance.
        </p>
      </div>

      <div className="row justify-content-center g-4">
        {/* Basic Plan */}
        <div className="col-md-4">
          <div className="card h-100 shadow-sm border-0">
            <div className="card-body d-flex flex-column justify-content-between p-4">
              <div>
                <h5 className="card-title fw-semibold">Basic Plan</h5>
                <p className="text-muted">Perfect for occasional maintenance</p>
                <h3 className="fw-bold mt-3">₹5,000</h3>
                <p className="text-success">50 Service Credits</p>
                <ul className="list-unstyled mt-3">
                  <li className="d-flex align-items-center mb-2"><img src={checkIcon} alt="Check" className="me-2" />50 Service Credits</li>
                  <li className="d-flex align-items-center mb-2"><img src={checkIcon} alt="Check" className="me-2" />Valid for 6 months</li>
                  <li className="d-flex align-items-center mb-2"><img src={checkIcon} alt="Check" className="me-2" />Access to all basic services</li>
                  <li className="d-flex align-items-center mb-2"><img src={checkIcon} alt="Check" className="me-2" />Priority scheduling</li>
                  <li className="d-flex align-items-center"><img src={checkIcon} alt="Check" className="me-2" />Service report with photos</li>
                </ul>
              </div>
              <button className="btn btn-success w-100 mt-4 pricing-btn d-flex align-items-center justify-content-center gap-2">
                <img src={phoneIcon} alt="Phone" width="20" height="20" />
                <span>Get Started</span>
              </button>
            </div>
          </div>
        </div>

        {/* Standard Plan */}
        <div className="col-md-4">
          <div className="card h-100 shadow-lg border-success border-2 position-relative">
            <div className="position-absolute top-0 start-50 translate-middle badge bg-success rounded-pill px-3 py-2">
              Most Popular
            </div>
            <div className="card-body d-flex flex-column justify-content-between p-4">
              <div>
                <h5 className="card-title fw-semibold">Standard Plan</h5>
                <p className="text-muted">Most popular for regular maintenance</p>
                <h3 className="fw-bold mt-3">₹12,000</h3>
                <p className="text-success">125 Service Credits</p>
                <ul className="list-unstyled mt-3">
                  <li className="d-flex align-items-center mb-2"><img src={checkIcon} alt="Check" className="me-2" />125 Service Credits</li>
                  <li className="d-flex align-items-center mb-2"><img src={checkIcon} alt="Check" className="me-2" />Valid for 12 months</li>
                  <li className="d-flex align-items-center mb-2"><img src={checkIcon} alt="Check" className="me-2" />Access to all services</li>
                  <li className="d-flex align-items-center mb-2"><img src={checkIcon} alt="Check" className="me-2" />Priority scheduling</li>
                  <li className="d-flex align-items-center mb-2"><img src={checkIcon} alt="Check" className="me-2" />Photo & video verification</li>
                  <li className="d-flex align-items-center"><img src={checkIcon} alt="Check" className="me-2" />Quarterly inspection reports</li>
                </ul>
              </div>
              <button className="btn btn-success w-100 mt-4 pricing-btn d-flex align-items-center justify-content-center gap-2">
                <img src={phoneIcon} alt="Phone" width="20" height="20" />
                <span>Get Started</span>
              </button>
            </div>
          </div>
        </div>

        {/* Premium Plan */}
        <div className="col-md-4">
          <div className="card h-100 shadow-sm border-0">
            <div className="card-body d-flex flex-column justify-content-between p-4">
              <div>
                <h5 className="card-title fw-semibold">Premium Plan</h5>
                <p className="text-muted">Comprehensive property care</p>
                <h3 className="fw-bold mt-3">₹25,000</h3>
                <p className="text-success">300 Service Credits</p>
                <ul className="list-unstyled mt-3">
                  <li className="d-flex align-items-center mb-2"><img src={checkIcon} alt="Check" className="me-2" />300 Service Credits</li>
                  <li className="d-flex align-items-center mb-2"><img src={checkIcon} alt="Check" className="me-2" />Valid for 18 months</li>
                  <li className="d-flex align-items-center mb-2"><img src={checkIcon} alt="Check" className="me-2" />Access to all premium services</li>
                  <li className="d-flex align-items-center mb-2"><img src={checkIcon} alt="Check" className="me-2" />Emergency service access</li>
                  <li className="d-flex align-items-center mb-2"><img src={checkIcon} alt="Check" className="me-2" />Monthly property inspection</li>
                  <li className="d-flex align-items-center"><img src={checkIcon} alt="Check" className="me-2" />Detailed reporting & consultation</li>
                </ul>
              </div>
              <button className="btn btn-success w-100 mt-4 pricing-btn d-flex align-items-center justify-content-center gap-2">
                <img src={phoneIcon} alt="Phone" width="20" height="20" />
                <span>Get Started</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center mt-5">
        <p className="text-muted">
          Credits are used based on the type and duration of service. For example, a standard home cleaning might use 5
          credits, while electrical repairs might use 10–20 credits depending on complexity.
        </p>
      </div>
      </div>
    </section>
  );
};

export default PricingSection;
